import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=a80da11a&"
import script from "./archive.vue?vue&type=script&lang=js&"
export * from "./archive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports